import { LoggedUserDetailService } from 'acl-cloud-lib';
import { MachineOwner, MachineOwnerService, User, UsersService } from '../../../api/generated';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class AuthUserServiceFakerService implements LoggedUserDetailService<User, MachineOwner> {

  constructor(
    private _userSvc: UsersService,
    private _machineOwnerSvc: MachineOwnerService
  ) {

  }

  loggedUserDetail(): Observable<User> {
    return new Observable<User>((observer) => {
      this._userSvc.loggedUser().subscribe(res => {
        observer.next(res);
      }, error => {
        observer.error(error);
      });
    });
  }

  loggedUserOwnerDetail(): Observable<MachineOwner> {
    return new Observable<MachineOwner>((observer) => {
      // this._machineOwnerSvc.logg().subscribe(res => {
      //   observer.next(res);
      // }, error => {
      //   observer.error(error);
      // });
    });
  }

}
